export default __webpack_public_path__ + "static/media/walfareindividual.de80eabc.png";